import React from 'react'
import { useLocation, useParams } from 'react-router-dom'
import PublicLayout from '~/components/PublicLayout'
import DownloadETours from '~/components/download/DownloadETours'

const App: React.FC = () => {
  const { disseminationKey }: { disseminationKey: string} = useParams();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
 
  const missingEToursOnly = queryParams.get('missingEToursOnly') || 'false';

  return (
    <PublicLayout>
      <DownloadETours  disseminationKey={disseminationKey} missingEToursOnly ={missingEToursOnly} />
    </PublicLayout>
  );
}

export default App;
